import React from 'react';

import { AgentCatalogLayout, CreateAgentDialog } from '../components';
import { useAgentCatalog } from '../hooks/useAgentCatalog';

export const AgentCatalogPage = () => {
    const {
        searchQuery,
        page,
        totalPages,
        showCreateDialog,
        agentsData,
        isAgentsLoading,
        paginationRange,

        handleSearchChange,
        handleAddAgent,
        handleChat,
        handleSettings,
        handleShare,
        handleDelete,
        handlePageChange,
        handleCreateSuccess,
        handleCloseCreateDialog,
    } = useAgentCatalog();

    return (
        <>
            <AgentCatalogLayout
                searchQuery={searchQuery}
                onSearchChange={handleSearchChange}
                onAddAgent={handleAddAgent}
                agents={agentsData?.data || []}
                isLoading={isAgentsLoading}
                onChat={handleChat}
                onSettings={handleSettings}
                onShare={handleShare}
                onDelete={handleDelete}
                currentPage={page}
                totalPages={totalPages}
                paginationRange={paginationRange || []}
                onPageChange={handlePageChange}
            />
            <CreateAgentDialog
                isOpen={showCreateDialog}
                onOpenChange={handleCloseCreateDialog}
                onFormSuccess={handleCreateSuccess}
            />
        </>
    );
};
